import "@nwga/ui/globals.css";

import { TRPCProvider } from "@nwga/features/client";
import { ThemeProvider } from "@nwga/ui/hooks/use-theme";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createRouter } from "./router.tsx";

const router = createRouter();
const { queryClient, api } = router.options.context;

const container = document.getElementById("root");
if (container === null) throw new Error("Missing #root element");

createRoot(container).render(
	<StrictMode>
		<ThemeProvider>
			<QueryClientProvider client={queryClient}>
				{/*
          The tRPC provider sits inside the query provider because it builds its
          options against that exact client — two query clients would give two
          caches and an invalidation that quietly hits neither.
        */}
				<TRPCProvider trpcClient={api} queryClient={queryClient}>
					<RouterProvider router={router} />
				</TRPCProvider>
			</QueryClientProvider>
		</ThemeProvider>
	</StrictMode>,
);
